import { useMutation } from '@tanstack/react-query';
import * as networking from '../lib/networking';
import { RhinoRecordIdentifier } from '../index';

export const CHECKOUT_API_PATH = '/api/_rhino/subscription/checkout';
export const PLAN_API_PATH = '/api/_rhino/subscription/plan';
export const PORTAL_API_PATH = '/api/_rhino/subscription/portal';

export interface CheckoutParams {
  base_owner_id: RhinoRecordIdentifier;
  package_ids: number[];
  return_path: string;
  trial?: boolean;
}

export interface UpdatePlanParams {
  base_owner_id: RhinoRecordIdentifier;
  package_ids: number[];
}

export interface PortalParams {
  base_owner_id: RhinoRecordIdentifier;
  return_path: string;
}

// Both endpoints return { url } (checkout also returns { sessionId }); the
// backend builds a hosted Stripe URL, so we just redirect the browser to it.
const redirectTo = (data: unknown) => {
  const url = (data as { url?: string })?.url;
  if (url) window.location.href = url;
};

export const useCheckout = () =>
  useMutation({
    mutationFn: (params: CheckoutParams) =>
      networking.networkApiCallOnlyData(CHECKOUT_API_PATH, {
        method: 'post',
        data: params
      }),
    onSuccess: redirectTo
  });

export const usePortal = () =>
  useMutation({
    mutationFn: (params: PortalParams) =>
      networking.networkApiCallOnlyData(PORTAL_API_PATH, {
        method: 'post',
        data: params
      }),
    onSuccess: redirectTo
  });

// Change the packages on an existing subscription in place. Unlike checkout
// there is no hosted page to redirect to; the caller refetches the subscription
// on success to reflect the new items (the backend reconciles them before
// responding).
export const useUpdatePlan = () =>
  useMutation({
    mutationFn: (params: UpdatePlanParams) =>
      networking.networkApiCallOnlyData(PLAN_API_PATH, {
        method: 'post',
        data: params
      })
  });
